import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClientXsrfModule  } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { RequireAuthenticationUserRouteGuardServiceService } from './services/security/require-authentication-user-route-guard-service.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModalBackdropComponent, ModalModule, TooltipModule } from 'ngx-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { CoreModule } from './core/core.module';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { NgIdleModule } from '@ng-idle/core'
import { SidebarModule } from 'primeng/sidebar';
import {FileUploadModule} from 'primeng/fileupload';
import { SettingsProviderService } from './settings-provider.service';
import { APP_INITIALIZER } from '@angular/core';
import { CommonService } from './services/common.service';
import { DialogModule } from 'primeng/dialog';
import { AccordionModule } from 'primeng/accordion';
import { UnsupportedBrowserComponent } from './unsupported-browser/unsupported-browser.component';
import { AuthService } from './services/security/auth.service';
import { MsalBroadcastService, MsalGuard, MsalInterceptor, MsalRedirectComponent, MsalService } from '@azure/msal-angular';
import { JwtInterceptor } from './interceptor/jwt.interceptor';

// (DE) 3/15/2019: Initialize environment variables.
export function init(settingsProvider: SettingsProviderService) {
  return () => {
    settingsProvider.loadAdminSetting();
    settingsProvider.loadHtmlTemplates();
    return settingsProvider.loadConfig();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,    
    UnsupportedBrowserComponent
  ],
  entryComponents: [
    ModalBackdropComponent    
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    HttpClientXsrfModule,
      FormsModule,
      ModalModule.forRoot(),
      TooltipModule,
      DialogModule,
    ConfirmDialogModule,
    RouterModule.forRoot([
      { path: '', component: HomeComponent, pathMatch: 'full' },      
      { path: 'dashboard', loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule), runGuardsAndResolvers: 'always' },
      { path: 'account', loadChildren: () => import('./modules/account/account.module').then(m => m.AccountModule), runGuardsAndResolvers: 'always' },
      { path: 'tutorial', loadChildren: () => import('./modules/tutorial/tutorial.module').then(m => m.TutorialModule), runGuardsAndResolvers: 'always' },
      { path: 'help', loadChildren: () => import('./modules/help/help.module').then(m => m.HelpModule), runGuardsAndResolvers: 'always' }
    ], { onSameUrlNavigation: 'reload', relativeLinkResolution: 'legacy' }),
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    ReactiveFormsModule,
    CoreModule,
    NgIdleModule.forRoot(),
    //NgIdleKeepaliveModule.forRoot(),
    SidebarModule,
    FileUploadModule,
    AccordionModule
  ],
  providers: [
    MsalInterceptor,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: init,
      deps: [SettingsProviderService],
      multi: true
    },
    SettingsProviderService,
    ConfirmationService,
    AuthService,
    RequireAuthenticationUserRouteGuardServiceService,
    CommonService,
    MsalGuard,
    MsalBroadcastService,
    MsalService
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }



